import { Group, GroupItem, Icon, Link, Text } from '@arc-ui/components';
import {
  EeIconCallCentreFill,
  EeIconNetwork,
  EeIconStore,
} from '@arc-ui/icons';
import { useHeaderContext } from '../../../contexts';

const iconMap: Record<string, string> = {
  'ee-icon--store-finder': EeIconStore,
  'ee-icon--network': EeIconNetwork,
  'ee-icon--call-centre': EeIconCallCentreFill,
};

function getApiIconKey(iconStr: string | undefined): string {
  return iconStr?.split(' ').find((tok) => tok.startsWith('ee-icon--')) ?? '';
}

export const UtilityLinks = (): React.ReactElement => {
  const { items: links = [] } = useHeaderContext();

  return (
    <div className="ee-utilityLinks" data-testid="ee-utilityLinks">
      <Group noWrap>
        {(links || []).map(({ title, linkUrl, icon }) => {
          const iconKey = getApiIconKey(icon);
          const iconString = iconMap[iconKey];
          return (
            <GroupItem key={title}>
              <span className="ee-utilityLinks-item">
                {iconString && (
                  <Icon icon={iconString} testId={iconKey} size={18} isInline />
                )}
                <Text id={title}>
                  <Link href={linkUrl} isImplied>
                    {title}
                  </Link>
                </Text>
              </span>
            </GroupItem>
          );
        })}
      </Group>
    </div>
  );
};
